import useTabContentQuery from "src/hooks/queries/useTabContentQuery"

const useTabContent = (id: string) => {
  const { data, isLoading } = useTabContentQuery(id)
  return { tabContent: data, isTabContentLoading: isLoading }
}

export default useTabContent
